<template>
    <div id="result-chart-co2-container" class="table-container relative" :style="bannerStyle">
        <h2>Übersicht Jahresgesamtkosten</h2>
        <div class="flex items-center">
            <div class="w-2/12 font-bold text-sm"></div>
            <div class="w-10/12"><h3>Jahresgesamtkosten in €/a</h3></div>
        </div>
        <div id="cost-chart">
            <div class="flex items-center chart-section chart-section-start">
                <div class="w-2/12 font-bold text-xs variant-label"></div>
                <div class="w-10/12">
                    <div class="chart-container">
                        <div v-for="(step,stepIndex) in finalStaps" class="y-axes" :style="'left: ' + ((stepIndex) * columnWidth) + '%'">
                            <div class="axes-label flex items-center justify-center lining-nums tabular-nums">
                                {{ formatValue((step) * chartCosts.steps, 'step') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-for="(chartDataset, chartIndex) in chartCosts.datasets">
                <div class="flex items-center chart-section" :class="[chartIndex == 0 ? 'first' : (chartIndex == (chartCosts.datasets.length -1) ? 'last' : '')]">
                    <div class="w-2/12 font-bold text-xs variant-label">
                        {{ chartDataset.label }}
                    </div>
                    <div class="w-10/12">
                        <div class="chart-container">
                            <div v-for="(step,stepIndex) in finalStaps" class="y-axes" :style="'left: ' + ((stepIndex) * columnWidth) + '%'">
                                <div class="axes-label flex items-center justify-center hidden lining-nums tabular-nums">
                                    {{ formatValue((step) * chartCosts.steps, 'step') }}
                                </div>
                            </div>
                            <div class="test" :style=" stepsNegative < 0 ? 'width: ' + containerWidth + '%; margin-left: ' + ((-stepsNegative) * columnWidth) + '%' : ''">
                                <div class="main-char-bar-container relative flex items-center flex-wrap justify-start">
                                    <div class="char-bar main-char-bar absolute left-0 top-0" :class="chartCosts.labels[3]+'-char-bar'" :data-label="chartCosts.labels[3]" :data-summe="chartDataset.data[3]" :style="'width: ' + getBarWidth(chartDataset.data[3]) + '%;'">
                                        <div class="char-index whitespace-nowrap pointer-events-none lining-nums tabular-nums flex items-center">
                                          {{ formatValue(chartDataset.index, 'index', '%') }}
                                        </div>
                                    </div>
                                    <div class="w-full">
                                        <template  v-for="(chartData,chartDataIndex) in chartDataset.data" >
                                            <div v-if="chartDataIndex < 3" class="small-bar-container w-full">
                                                <div class="char-bar small-bar" :class="chartCosts.labels[chartDataIndex]+'-char-bar'" :data-label="chartCosts.labels[chartDataIndex]" :data-summe="chartData" :style="'width: ' + getBarWidth(chartData) + '%;' + ((chartData<0) ? ' left: auto; right: ' + (getBarWidth(chartData)  ) + '%; ' : '')" ></div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="flex items-center chart-section chart-section-end">
                <div class="w-2/12 font-bold text-xs variant-label"></div>
                <div class="w-10/12">
                    <div class="chart-container">
                        <div v-for="(step,stepIndex) in finalStaps" class="y-axes" :style="'left: ' + ((stepIndex) * columnWidth) + '%'">
                            <div class="axes-label flex items-center justify-center lining-nums tabular-nums">
                                {{ formatValue((step) * chartCosts.steps, 'step') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex items-center mb-10">
            <div class="w-2/12 h-5">
            </div>
            <div class="flex flex-nowrap w-10/12 pt-4">
                <div v-for="(chartLabel, chartLabelIndex) in chartCosts.labels" class="flex items-center w-3/12 pr-4">
                    <div class="chart-label-color w-8 h-4 mr-2" :style="'background-color: ' + chartColors[chartLabelIndex]"></div>
                    <div class="text-xs">{{ $t('result.' + chartLabel) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {getCurrentInstance} from "vue";

export default {
    props: {
        chartCosts: {
            type: Object,
            required: false,
            default: {}
        }
    },
    computed: {
        chartHeight() {

            const chartHeight = (this.chartPaddingY * 2) + this.barHeight;
            return chartHeight;
        },
        barHeight() {
            return 68
        },
        smallBarHeight() {
            return 12
        },
        chartPaddingY() {
            return 15
        },
        bannerStyle() {
            return {
                '--chart-height': `${this.chartHeight}px`,
                '--chart-height-2': `${(this.chartHeight + this.chartPaddingY)}px`,
                '--bar-height': `${this.barHeight}px`,
                '--small-bar-height': `${this.smallBarHeight}px`,
                '--chart-padding-y': `${this.chartPaddingY}px`,
                '--chart-padding-y-2': `${(this.chartPaddingY * 2)}px`,
                '--chart-border-color': '#dddddd'
            }
        }
    },
    setup(props) {
        const internalInstance = getCurrentInstance();
        const accounting = internalInstance.appContext.config.globalProperties.$accounting;
        const chartColors = ["#0068af", "#c20000", "#576874", "#d8dfe4"]
        const chartCosts = props.chartCosts;

        const steps = (chartCosts.max / chartCosts.steps);
        const stepsNegative = (chartCosts.min / chartCosts.steps);
        var finalStaps = [];

        for (let i = stepsNegative; i <= steps; i++) {
            finalStaps.push(i)
        }

        const allSteps = steps - stepsNegative
        const containerWidth = (100 * steps) / allSteps;
        const columnWidth = 100 / allSteps;

        const getBarWidth = (charData) => {

            if(charData<0){
                charData = charData * -1
            }
            console.log(charData,(100 * charData) / chartCosts.max)
            return (100 * charData) / chartCosts.max
        }

        const formatValue = (value, row, unit) => {
            if (value == '-') return value;
            if (['energieeffizienzklasse_endenergiebedarf'].includes(row)) return value;

            var precision = 2;
            if (['step','index'].includes(row)) precision = 0

            return accounting.formatMoney(value, {
                symbol: '',
                format: '%v',
                precision: precision,
                decimal: ',',
                thousand: '.'
            }) + (unit ? ' ' + unit : '');
        }

        return {
            chartCosts,
            steps,
            columnWidth,
            getBarWidth,
            formatValue,
            chartColors,
            allSteps,
            finalStaps,
            containerWidth,
            stepsNegative
        }
    },
}
</script>

<style lang="scss" scoped>
#cost-chart {
    margin: 20px 0;
    padding: 30px 0;
}

.char-bar {
    position: absolute;
    left: 0;
}

.char-index {
    position: absolute;
    width: 0;
    height: 100%;
    right: -10px;
    font-size: 10px;

}
.main-char-bar-container{
    top: var(--chart-padding-y);
    height: var(--bar-height);
}

.main-char-bar {

    height: var(--bar-height);
    background-color: #333333;
}
.small-bar{
    height:  var(--small-bar-height);
    position: relative;

}
.small-bar-container{
    height:  var(--small-bar-height);
    margin: 3px 0px;
    float: left;
}
.jahres_gesamtkosten-char-bar{

    background-color: #d8dfe4;
}
.verbrauchsgebundene_kosten-char-bar{
    background-color: #0068af;
}
.kapitalgebundene_kosten-char-bar{
    background-color: #c20000;
}
.betriebsgebundene_kosten-char-bar{
    background-color: #576874;
}

.y-axes {
    position: absolute;
    /*height: var(--chart-height);*/
    bottom: 0;
    top: 0;
    width: 1px;
    background-color: var(--chart-border-color);

    .axes-label {
        pointer-events: none;
        position: absolute;
        width: 30px;
        margin-left: -15px;
        height: 0;
        font-size: 10px;
        text-align: center;
    }
}


.chart-section {
    .variant-label{
        padding-right: 10px;
    }
    .chart-container {
        position: relative;
        height: var(--chart-height);
    }

    &.chart-section-start {
        .chart-container {
            border-bottom: 1px solid var(--chart-border-color);
            height: 20px;

            .axes-label {
                height: 30px;
                top: -30px;

            }
        }
    }

    &.chart-section-end {
        .chart-container {
            border-top: 1px solid var(--chart-border-color);

            height: 20px;

            .axes-label {
                height: 30px;
                bottom: -30px;
            }
        }
    }

    &.first {
        .variant-label{ margin-top: var(--chart-padding-y) }
        .chart-container {
            .main-char-bar-container {
                top: var(--chart-padding-y-2);
            }
            height: var(--chart-height-2);
        }
    }

    &.last {
        .chart-container {
            height: var(--chart-height-2);
        }
    }

}

</style>
